'use strict';
/**
 * A service to get all of the recent activity in the community.
 */

angular.module('msCommunity').service('sharedAnswerSvc', ['httpSvc', function (httpSvc) {
  function getExamples(activity) {
    return httpSvc.get('/apiproxy/user/activities/responses/shared/' + activity.id + '?status=EXAMPLE');
  }

  return {
    getExamples: getExamples
  };
}]);